import React from "react";
import Footer from "./Footer";

function Kontak() {
  return (
    <div className="text-xl" data-aos="zoom-up">
      <h1 className="text-2xl md:text-3xl font font-semibold mb-2 dark:text-gray-200">
        Kontak Saya
      </h1>
      <hr className="border-2 borderd-slate-700 dark:border-gray-200 w-1/2 mt-10" />
      <p className="text-lg font-semibold md:text-xl my-4 dark:text-gray-200">
        | Untuk kepentingan terkait project atau kerjaan
      </p>
      <p className="text-lg md:text-xl font-normal mt-4 dark:text-gray-200">
        <b>
          [<i class="bi bi-envelope-heart"></i> Email] :
        </b>{" "}
        ariamubin79@gmail.com
      </p>
      <p className="text-lg md:text-xl font-normal mt-10 dark:text-gray-200">
        <b>
          [<i class="bi bi-github"></i> Github] :
        </b>{" "}
        github.com/mubin-mhd
      </p>
      <p className="text-lg font-semibold md:text-xl my-4 dark:text-gray-200">
        | FAQ (source project di github) mau kontribusi silahkan atau mau copas
        source code semuanya silahkan <b>Halal😉</b>
      </p>
      <hr className="border-2 borderd-slate-700 dark:border-gray-200 w-1/2" />
      <p className="text-lg font-semibold md:text-xl my-4 dark:text-gray-200">
        | Sosial media
      </p>
      <p className="text-lg md:text-xl font-normal mt-4 dark:text-gray-200">
        <b>
          [<i class="bi bi-instagram"></i> Instagram] :
        </b>{" "}
        @mubinn-mhd
      </p>
      <p className="text-lg md:text-xl font-normal mt-4 dark:text-gray-200">
        <b>
          [<i class="bi bi-twitter"></i> Twitter] :
        </b>{" "}
        @binmubin2
      </p>
      <p className="text-lg md:text-xl font-normal mt-4 dark:text-gray-200">
        <b>
          [<i class="bi bi-youtube"></i> Youtube] :
        </b>{" "}
        @kodebin
      </p>
      <p className="text-lg md:text-xl font-normal mt-4 dark:text-gray-200">
        <b>
          [<i class="bi bi-facebook"></i> Facebook] :
        </b>{" "}
        Mukhammad Nur Mubin
      </p>
      <p className="text-lg font-semibold md:text-xl my-4 dark:text-gray-200">
        | FAQ (apa semua aktif ?) Sering aktif di instagram selebihnya jarang di
        gunakan
      </p>
      <hr className="border-2 borderd-slate-700 dark:border-gray-200 w-1/2" />
      <p className="text-lg font-semibold md:text-xl my-4 dark:text-gray-200">
        | Undangan digital klik{" "}
        <span className="underline underline-offset-4 decoration-4 decoration-sky-500">
          <a href="https://mubin-mhd.github.io/undangresepsi/">undangresepsi</a>
        </span>{" "}
        atau lihat template di instagram
      </p>
      <p className="text-lg md:text-xl font-normal mt-4 dark:text-gray-200">
        <b>
          [<i class="bi bi-instagram"></i> Instagram] :
        </b>{" "}
        @undangresepsi
      </p>
      <Footer />
    </div>
  );
}

export default Kontak;
